// Import dependencies
import React, { createElement, useState } from "react";

// Import styles
import {
  Progress,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import "./SkillsCard.css";

const SkillsCard = (props) => {
  // Content
  const { name, logo, porcent, progressBar, icon } = props.skill;

  // State for open or close modal
  const [modalIsOpen, setModalIsOpen] = useState(false);

  // State for select a skill
  const [selectSkill, setSelectSkill] = useState(null);

  // Functions for open and close modal
  function openModal() {
    setModalIsOpen(true);
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  return (
    <>
      {/* Modal */}
      <Modal isOpen={modalIsOpen}>
        <ModalHeader>
          <div className="flex items-center gap-2 align-middle mb-3">
            <img src={selectSkill?.logo} alt="Logo skill" className="h-10" />

            <h6 className="text-[18px]">{selectSkill?.name}</h6>
          </div>
        </ModalHeader>
        <ModalBody>
          {selectSkill?.text.map((para, index) => (
            <p key={index}>{para.paragraph}</p>
          ))}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeModal}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>

      <div
        className="mt-4 flex flex-col justify-center bg-white_txt sm:cursor-pointer relative group w-full gap-4 p-2 max-w-sm rounded-md border-2 border-slate-200 hover:scale-100"
        onClick={() => {
          setSelectSkill(props.skill);
          openModal();
        }}
      >
        <div className="flex items-center gap-4">
          <img
            src={logo}
            alt="Logo Skill"
            className="w-10 group-hover:scale-125 duration-200"
          />

          <h6>{name}</h6>

          <div className="text-xl text-dark_primary absolute top-3 right-3">
            {createElement(icon)}
          </div>
        </div>

        <Progress
          animated
          value={porcent}
          max={100}
          className={progressBar}
        ></Progress>
      </div>
    </>
  );
};

export default SkillsCard;
